export const BANNER_SRC =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_d3492dd1-567c-4bd4-a0be-b6d2cefb5b61/artifacts/n5mej9rn_ChatGPT%20Header_Logo%20Aug%2010%2C%202026%2C%2002_33_01%20PM.png";

export const BANNER_ALT =
  "No Glyph Studios — Filling the void with independent art.";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};
